import React from 'react';
import { Col, Row, Text } from 'tea-component';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import { useDealwithPlatform } from '../../../hooks';
import { useIntl } from 'umi';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { formatSimpleTimeFunc } from '@/pages/opinion/utils/time';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';
import BubbleCommon, {
  steamPerformanceAllReviewsTips,
} from '@op/components/BubbleCommon';

export default function SteamStoreScoreBox({
  storeScoreInfo,
  steamReviews,
  loading,
  changeTime,
  show,
  time,
  isToday,
  addedTime,
}: any) {
  const { steamElement, steamAddedReviewElement } = useDealwithPlatform({
    data: storeScoreInfo,
    setTime: changeTime,
    isToday,
    show,
    steamReviews,
  });
  const { formatMessage } = useIntl();

  return (
    <CardCommon
      loading={loading}
      loadingHeight={280}
      contentCard
      className="dbo-steam-store-score-box"
    >
      <Row>
        <Col span={12} className="steam-score-reviews-left">
          <CardCommon
            className="dbo-steam-added-reviews"
            contentCard
            title={
              <div className="dbo-steam-reviews-title">
                <SvgIcon className="title-icon-info" type="new-logo"></SvgIcon>
                {formatMessage({ id: 'Added Reviews' })}
                {/* <Text theme="label" className="title-tips max-screen-show">
                  {formatMessage({
                    id: 'Collected via DataBrain crawler, with statistics generated based on filters',
                  })}
                </Text> */}
                {/*  min-screen-show */}
                <Text theme="label" className="title-tips">
                  {formatMessage({
                    id: 'Collected via DataBrain crawler',
                  })}
                </Text>
              </div>
            }
            operations={
              addedTime
                ? [
                    {
                      element: (
                        <div className="storescorebox-item-flex-time">
                          {addedTime}
                        </div>
                      ),
                    },
                  ]
                : []
            }
          >
            <div className="dbo-steam-reviews-progress">
              {steamAddedReviewElement}
            </div>
          </CardCommon>
        </Col>
        <Col span={12} className="steam-score-reviews-right">
          <CardCommon
            className="steam-feeds-reviews-detailed-wrapper"
            contentCard
            title={
              <div className="dbo-steam-reviews-title">
                <ChannelLabel
                  className="title-icon-info"
                  channel_name={'steam'}
                  showText={false}
                ></ChannelLabel>
                {formatMessage({ id: 'All Reviews' })}
                {/*  min-screen-show max-screen-show */}
                <Text className="title-tips">
                  {formatMessage({
                    id: 'Data statistics are directly sourced from the Steam page',
                  })}
                </Text>
                <BubbleCommon
                  tipsMap={steamPerformanceAllReviewsTips}
                  placement="top"
                />
              </div>
            }
            alwaysShowOperations
            operations={[
              {
                element: (
                  <div className="storescorebox-item-flex-time">
                    {time.steam && formatSimpleTimeFunc(time.steam)}
                  </div>
                ),
              },
            ]}
          >
            <div className="dbo-steam-reviews-progress">{steamElement}</div>
          </CardCommon>
        </Col>
      </Row>
      {/* <div className={`feeds-storescorebox `}>
        <div className="storescorebox-item"></div>
        <div className="storescorebox-item">
          <div className="storescorebox-item-bd"></div>
        </div>
      </div> */}
    </CardCommon>
  );
}
